<template>
  <div>
    <b-card>
      <div class="report-scope-heading">
        <h4 class="mb-0">
          {{ $t('downlineReports.betsTitle') }}
        </h4>
        <b-button
          v-if="summarySourceAgent"
          variant="outline-primary"
          size="sm"
          @click="backToSummary"
        >
          {{ $t('downlineReports.backSummary') }}
        </b-button>
      </div>
      <b-form @submit.prevent="onSubmit">
        <b-row class="mt-1 text-left">
          <b-col
            v-if="canSelectReportAgent"
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('downlineReports.scopeAgent')"
              label-for="mc-agent"
            >
              <agent-selector
                v-model="selectedAgent"
                input-id="mc-agent"
                source="downlineBets"
                :auto-select-default="false"
                :emit-self-as-option="true"
                :clearable="false"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('ยูสเซอร์เนม')"
              label-for="mc-username"
            >
              <b-form-input
                id="mc-username"
                v-model="form.username"
                :placeholder="$t('Username')"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('วันที่เริ่มต้น')"
              label-for="mc-start"
            >
              <flat-pickr
                v-model="startDate"
                class="form-control"
                :config="{ disableMobile:true,enableTime: !scopedAgent,dateFormat: scopedAgent ? 'd/m/Y' : 'd/m/Y H:i:S' , enableSeconds:!scopedAgent , time_24hr:true}"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('วันที่สิ้นสุด')"
              label-for="mc-ebd"
            >
              <flat-pickr
                v-model="endDate"
                class="form-control"
                :config="{ disableMobile:true,enableTime: !scopedAgent,dateFormat: scopedAgent ? 'd/m/Y' : 'd/m/Y H:i:S' , enableSeconds:!scopedAgent , time_24hr:true}"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('ประเภทหวย')"
              label-for="mc-type"
            >
              <v-select
                v-model="form.type"
                label="title"
                :options="$tOptions(gameTypes)"
                :get-option-label="$tDisplay"
                :placeholder="$t('ประเภทหวย')"
                @input="selectedType"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('ประเภทการเเทง')"
              label-for="mc-type"
            >
              <v-select
                v-model="form.betType"
                label="ประเภทการเเทง"
                :clearable="false"
                :options="$tOptions(options)"
                :get-option-label="$tDisplay"
                append-to-body
                :placeholder="$t('ประเภทการเเทง')"
                @input="selectedBetType"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 4"
            :lg="canSelectReportAgent ? 3 : 4"
          >
            <b-form-group
              :label="$t('เลข')"
              label-for="mc-number"
            >
              <b-form-input
                id="mc-number"
                v-model="form.number"
                :placeholder="$t('เลข')"
                :minlength="numberLength"
                :maxlength="numberLength"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            :md="canSelectReportAgent ? 6 : 12"
            :lg="canSelectReportAgent ? 3 : 12"
            :class="canSelectReportAgent ? 'd-flex align-items-end' : 'text-right'"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :class="{ 'w-100 mb-1': canSelectReportAgent }"
              type="submit"
              variant="primary"
            >
              {{ $t('Search') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-alert
      :show="!!reportError"
      variant="danger"
    >
      {{ reportError }}
    </b-alert>
    <b-card
      title=""
    >
      <b-table
        ref="reportTable"
        responsive
        :fields="$tFields(reportColumns)"
        :per-page="pagination.rowsPerPage"
        :current-page="pagination.page"
        :items="onRequest"
        :filter="filter"
        bordered
      >
        <template #cell(username)="v">
          <span
            v-if="scopedAgent"
            class="font-weight-bolder"
          >{{ v.value }}</span>
          <span
            v-else
            style="text-decoration: underline;cursor: pointer"
            class="font-weight-bolder"
            @click="showUserDetial(v.value, v.item.prefix)"
          >
            {{ v.value }}
          </span>
        </template>
        <template #cell(settlementBet)="v">
          {{ v.value.toFixed(2) }}
        </template>
        <template #cell(settlementNet)="v">
          <span :class="textColorWithTwoColor(v.value)">{{ v.value.toFixed(2) }}</span>
        </template>
        <template #cell(betNumber)="v">
          <div class="font-weight-bolder">
            {{ v.value }}
          </div>
        </template>
        <template #cell(status)="v">
          <div>
            <b-button
              v-if="v.value === -1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="cyan-7"
            >{{ $t('Refund') }}
            </b-button>
            <b-button
              v-else-if="v.value === 0"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="relief-secondary"
            >{{ $t('Waiting') }}
            </b-button>
            <b-button
              v-else-if="v.value === 1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="success"
            >{{ $t('Win') }}
            </b-button>
            <b-button
              v-else-if="v.value === 2"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="danger"
            >{{ $t('Lose') }}
            </b-button>
          </div>
        </template>
        <template #cell(payPercen)="v">
          <div class="font-weight-bolder">
            {{ v.value.toFixed(2) }}
          </div>
        </template>
        <template #cell(betAmount)="v">
          <div class="font-weight-bolder">
            {{ v.value.toFixed(2) }}
          </div>
        </template>
        <template #cell(winLose)="v">
          <div class="font-weight-bolder">
            <span :class="textColorWithTwoColor(v.value)">
              {{ v.value.toFixed(2) }}
            </span>
          </div>
        </template>
        <template #cell(rollingAmount)="v">
          <div>{{ v.value.toFixed(2) }}</div>
        </template>
        <template #cell(betType)="v">
          <div v-if="v.item.huayId === '1'">
            {{ betTypeLabel(v.value, betTypeTextGov) }}
          </div>
          <div v-else>
            {{ betTypeLabel(v.value, getBetType(v.item.huayId)) }}
          </div>
        </template>
        <template #cell(cashBack)="v">
          <div class="font-weight-bolder">
            <template v-if="v.item.package && v.item.package.cashBackAmount > 0">
              <span
                v-if="v.item.package.cashBackMode === 1"
                class="text-success"
              >
                {{ v.item.package.cashBackAmount.toFixed(2) }} ({{ $t('ส่วนลด') }})
              </span>
              <span
                v-else
                class="text-info"
              >
                {{ v.item.package.cashBackAmount.toFixed(2) }} ({{ $t('คืน') }})
              </span>
            </template>
            <template v-else>
              0.00
            </template>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="2"
        >
          <b-form-group class="text-nowrap">
            <label class="d-inline-block  mr-50 text-sm-right font-small-4">{{ $t('Per page') }}</label>
            <b-form-select
              v-model="pagination.rowsPerPage"
              size="sm"
              :options="$tOptions(reportRowsOptions)"
              class="w-50"
              style="min-width: 100px"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="8"
          md="6"
          sm="12"
        >
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.rowsNumber"
            :per-page="pagination.rowsPerPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BAlert,
  BFormSelect,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BRow,
  BTable,
  BPagination,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import lottoService from '@/service/lottoService'
import fourFiveDigitService from '@/service/fourFiveDigitService'
import {
  FOUR_FIVE_DIGIT_LABELS, betTypeLabel, fourFiveDigitAccessOf, fourFiveDigitLength,
} from '@/utils/betTypes'
import settlementService from '@/service/settlementService'
import AgentSelector from '@core/components/agent/AgentSelector.vue'
import flatPickr from 'vue-flatpickr-component'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    AgentSelector,
    BAlert,
    flatPickr,
    BTable,
    BCardBody,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormDatepicker,
    BPagination,
    BFormSelect,
    vSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      selectedAgent: null,
      canSelectReportAgent: false,
      agentAccessRequestId: 0,
      form: {
        username: '',
        type: '',
        betType: '',
        number: '',
      },
      options: [
        'ทั้งหมด',
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
      ],
      mapValue: {
        สามตัวบน: 1,
        สามตัวโต้ด: 2,
        สามตัวหน้า: 3,
        สามตัวท้าย: 4,
        สองตัวบน: 5,
        สองตัวล่าง: 6,
        วิ่งบน: 7,
        วิ่งล่าง: 8,
        เลขชุด: 9,
        ...Object.fromEntries(Object.entries(FOUR_FIVE_DIGIT_LABELS).map(([type, label]) => [label, Number(type)])),
      },
      // 4/5 ตัว: { [huayId]: ประเภทที่ใช้ได้ } สำหรับตัวเลือกประเภทของหวยที่เลือก
      fourFiveDigitAccess: {},
      gameTypes: [
        'ทั้งหมด',
      ],
      gameTypesMapper: {},
      huayTypesMapper: {},
      rowsOptions: [5, 10, 15, 25, 50, 100, 250, 500, 'all'],
      type: '',
      loading: false,
      reportError: '',
      reportRequestId: 0,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        rowsNumber: 10,
      },
      columns: [
        {
          key: 'betTime',
          label: 'วัน/เวลา',
          class: 'text-nowrap',
        },
        {
          key: 'prefix',
          label: 'Prefix',
          class: 'text-nowrap text-right',
        },
        {
          key: 'username',
          label: 'Username',
          class: 'text-nowrap',
        },
        {
          key: 'huayName',
          label: 'Huay Name',
          class: 'text-nowrap',
        },
        {
          key: 'betType',
          label: 'Bet Type',
          class: 'text-nowrap',
        },
        {
          key: 'betNumber',
          label: 'Bet Number',
          class: 'text-nowrap text-center',
        },
        {
          key: 'betId',
          label: 'Bet ID',
          class: 'text-nowrap',
        },
        {
          key: 'roundId',
          label: 'Round ID',
          class: 'text-nowrap',
        },
        {
          key: 'payPercen',
          label: 'อัตราจ่าย',
          class: 'text-nowrap',
        },
        {
          key: 'cashBack',
          label: 'CashBack',
          class: 'text-nowrap',
        },
        {
          key: 'status',
          label: 'Status',
          class: 'text-center text-nowrap',
        },
        {
          key: 'betAmount',
          label: 'Bet Amount',
          class: 'text-nowrap',
        },
        {
          key: 'winLose',
          label: 'Win/Lose',
          class: 'text-nowrap',
        },
      ],
      data: [],
      // startDate: this.$store.state.app.DateFormat(new Date(new Date().getTime() - 60 * 60000)),
      startDate: this.$store.state.app.DateFormat(new Date(new Date().setHours(0, 0, 0, 0))),
      endDate: this.$store.state.app.DateFormat(new Date()),
      filter: '',
      summation: {
        betAmount: 0,
        winLose: 0,
        rollingAmount: 0,
      },
      mapValueLimit: {
        สามตัวบน: 3,
        สามตัวโต้ด: 3,
        สามตัวหน้า: 3,
        สามตัวท้าย: 3,
        สองตัวบน: 2,
        สองตัวล่าง: 2,
        วิ่งบน: 1,
        วิ่งล่าง: 1,
        เลขชุด: 4,
        ...Object.fromEntries(Object.entries(FOUR_FIVE_DIGIT_LABELS).map(([type, label]) => [label, fourFiveDigitLength(type)])),
      },
      betTypeTextGov: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
      ],
      betTypeText: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
        'เลขชุด',
      ],
      betTypeTextYk: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
        'เลขชุด',
      ],
      numberLength: 4,
    }
  },
  computed: {
    summarySourceAgent() {
      return typeof this.$route.query.sourceAgent === 'string' ? this.$route.query.sourceAgent.trim() : ''
    },
    scopedAgent() {
      return typeof this.$route.query.agent === 'string' ? this.$route.query.agent : ''
    },
    reportRowsOptions() {
      return this.scopedAgent ? this.rowsOptions.filter(v => v !== 'all') : this.rowsOptions
    },
    reportColumns() {
      if (!this.scopedAgent) return this.columns
      return [
        { key: 'agent', label: this.$t('downlineReports.agent'), class: 'text-nowrap' },
        ...this.columns,
        { key: 'settlementBet', label: this.$t('downlineReports.settlementBet'), class: 'text-nowrap text-right' },
        { key: 'settlementNet', label: this.$t('downlineReports.settlementNet'), class: 'text-nowrap text-right' },
      ]
    },
  },
  watch: {
    '$route.query'() {
      this.restoreScope()
      this.loadAgentAccess()
    },
  },
  beforeMount() {
    this.restoreScope()
    this.loadAgentAccess()
  },
  beforeDestroy() {
    this.reportRequestId += 1
    this.agentAccessRequestId += 1
  },
  async mounted() {
    fourFiveDigitService.access(null, true).then(access => { this.fourFiveDigitAccess = access })
    lottoService
        .getAuthen('huay/dict')
        .then(res => {
          // eslint-disable-next-line no-restricted-syntax
          for (const v of res.data) {
            this.gameTypes.push(v.name)
            this.huayTypesMapper[v.name] = v.type
            this.gameTypesMapper[v.name] = v.id
          }
          lottoService
              .getAuthen('yeekee/dict')
              .then(res2 => {
                // eslint-disable-next-line no-restricted-syntax
                for (const v of res2.data) {
                  this.gameTypes.push(v.name)
                  this.huayTypesMapper[v.name] = v.type
                  this.gameTypesMapper[v.name] = v.id
                }
              })
        })
    if (this.$route.query.id !== undefined) {
      this.username = this.$route.query.id
    }
  },
  methods: {
    async loadAgentAccess() {
      const requestId = ++this.agentAccessRequestId
      try {
        // Two permitted targets suffice to distinguish self-only access from
        // access to another agent. Permission is decided by the report API.
        const res = await settlementService.getAuthen('settlement/bets/agents?page=1&limit=2')
        if (requestId !== this.agentAccessRequestId) return
        const ownAgent = this.$store.state.app.userData?.agent
        this.canSelectReportAgent = res.status === 200 && Array.isArray(res.data?.data)
          && !!ownAgent && res.data.data.some(agent => agent.username !== ownAgent)
      } catch (error) {
        if (requestId === this.agentAccessRequestId) this.canSelectReportAgent = false
      }
    },
    restoreScope() {
      this.reportRequestId += 1
      this.reportError = ''
      const queryText = key => typeof this.$route.query[key] === 'string' ? this.$route.query[key] : ''
      this.form = {
        username: queryText('username'), type: queryText('filterType'),
        betType: queryText('filterBetType'), number: queryText('number'),
      }
      this.selectedAgent = this.scopedAgent
        ? { code: this.scopedAgent, username: this.scopedAgent, label: this.scopedAgent } : null
      if (this.scopedAgent) {
        if (!Number.isInteger(this.pagination.rowsPerPage) || this.pagination.rowsPerPage < 1) this.pagination.rowsPerPage = 25
        const { startDate, endDate } = this.$route.query
        this.startDate = typeof startDate === 'string' ? startDate.split('-').reverse().join('/') : ''
        this.endDate = typeof endDate === 'string' ? endDate.split('-').reverse().join('/') : ''
      } else {
        this.startDate = this.$store.state.app.DateFormat(new Date(new Date().setHours(0, 0, 0, 0)))
        this.endDate = this.$store.state.app.DateFormat(new Date())
      }
      if (typeof this.$route.query.username === 'string') this.form.username = this.$route.query.username
      this.applyFilters()
    },
    backToSummary() {
      if (!this.summarySourceAgent) return
      const query = { startDate: this.$route.query.startDate, endDate: this.$route.query.endDate }
      query.agent = this.summarySourceAgent
      this.$router.push({ name: 'settlement', query })
    },
    textColorWithTwoColor(v) {
      if (v < 0) {
        return 'text-danger'
      }
      if (v > 0) {
        return 'text-success'
      }
      return ''
    },
    selectedType() {
      this.form.number = ''
      if (this.form.type === 'ทั้งหมด') {
        this.form.betType = 'ทั้งหมด'
        return
      }
      const type = this.huayTypesMapper[this.form.type]
      if (type === 5) {
        this.options = [
          'เลขชุด',
        ]
        this.form.betType = 'เลขชุด'
        this.numberLength = 4
      } else if (type === 1) {
        this.numberLength = 3
        this.options = [
          'ทั้งหมด',
          'สามตัวบน',
          'สามตัวโต้ด',
          'สามตัวหน้า',
          'สามตัวท้าย',
          'สองตัวบน',
          'สองตัวล่าง',
          'วิ่งบน',
          'วิ่งล่าง',
          ...this.fourFiveDigitOptions(),
        ]
        this.form.betType = 'ทั้งหมด'
      } else {
        this.numberLength = 3
        this.options = [
          'ทั้งหมด',
          'สามตัวบน',
          'สามตัวโต้ด',
          'สองตัวบน',
          'สองตัวล่าง',
          'วิ่งบน',
          'วิ่งล่าง',
          ...this.fourFiveDigitOptions(),
        ]
        this.form.betType = 'ทั้งหมด'
      }
    },
    // ป้ายของประเภท 4/5 ตัวที่หวยที่เลือกใช้ได้ (ต่อท้ายตัวเลือกประเภท) · ห้องยี่กีใช้ชุดของยี่กี
    fourFiveDigitOptions() {
      return fourFiveDigitAccessOf(this.fourFiveDigitAccess, this.gameTypesMapper[this.form.type])
        .map(type => FOUR_FIVE_DIGIT_LABELS[type])
    },
    betTypeLabel,
    selectedBetType() {
      if (this.form.betType === 'ทั้งหมด') {
        this.numberLength = 3
      } else {
        this.numberLength = this.mapValueLimit[this.form.betType]
      }
      if (this.form.number.length !== this.numberLength) {
        this.form.number = ''
      }
    },
    getBetType(id) {
      return id.length === 24 ? this.betTypeTextYk : this.betTypeText
    },
    onSubmit() {
      if (this.scopedAgent || (this.canSelectReportAgent && this.selectedAgent?.code)) {
        const query = {
          ...this.$route.query,
          agent: this.selectedAgent?.code || this.scopedAgent,
          startDate: this.startDate.split(' ')[0].split('/').reverse().join('-'),
          endDate: this.endDate.split(' ')[0].split('/').reverse().join('-'),
          username: this.form.username,
          filterType: this.form.type,
          type: this.gameTypesMapper[this.form.type]
            || (this.form.type === this.$route.query.filterType ? this.$route.query.type : '') || '',
          filterBetType: this.form.betType,
          number: this.form.number,
        }
        if (Object.keys(query).some(key => (this.$route.query[key] || '') !== query[key])) {
          this.$router.push({ name: 'lotto-report', query })
          return
        }
      }
      this.applyFilters()
    },
    applyFilters() {
      const {
        username,
        type,
        betType,
        number,
      } = this.form

      this.pagination.page = 1
      const params = new URLSearchParams()
      params.set('startDate', this.scopedAgent ? this.startDate.split('/').reverse().join('-') : this.startDate)
      params.set('endDate', this.scopedAgent ? this.endDate.split('/').reverse().join('-') : this.endDate)
      if (this.scopedAgent) params.set('agent', this.scopedAgent)
      if (username) params.set('username', username)
      if (type && type !== 'ทั้งหมด') {
        const typeId = this.gameTypesMapper[type]
          || (this.scopedAgent && type === this.$route.query.filterType ? this.$route.query.type : '')
        if (typeId) params.set('type', typeId)
      }
      if (betType && betType !== 'ทั้งหมด') params.set('betType', this.mapValue[betType])
      if (number) params.set('number', number)
      const nextFilter = `&${params.toString()}`
      const refreshScope = this.scopedAgent && this.filter === nextFilter
      this.filter = nextFilter
      // The provider does not run when the filter value stays equal. Recheck
      // scoped access even when the user searches the same dates again.
      if (refreshScope && this.$refs.reportTable) this.$refs.reportTable.refresh()
    },
    // eslint-disable-next-line consistent-return
    async onRequest() {
      let {
        // eslint-disable-next-line prefer-const
        page,
        rowsPerPage,
        // eslint-disable-next-line prefer-const
        rowsNumber,
        // eslint-disable-next-line prefer-const
        sortBy,
        // eslint-disable-next-line prefer-const
        descending,
      } = this.pagination

      if (rowsPerPage === 'all') {
        rowsPerPage = 0
      }
      const startRow = (page - 1) * rowsPerPage
      const fetchCount = rowsPerPage === 0 ? rowsNumber : rowsPerPage

      this.loading = true
      this.reportError = ''
      const requestId = ++this.reportRequestId
      const scoped = !!this.scopedAgent
      let res
      try {
        const service = scoped ? settlementService : lottoService
        const path = scoped ? 'settlement/bets' : 'bet'
        res = await service.getAuthen(`${path}?limit=${fetchCount}&page=${startRow}${this.filter}`)
        if (requestId !== this.reportRequestId) return []
        if (res.status !== 200) throw new Error('Report access failed')
      } catch (error) {
        if (requestId !== this.reportRequestId) return []
        this.loading = false
        this.pagination.rowsNumber = 0
        this.reportError = this.$t('downlineReports.loadError')
        return []
      }
      if (res.status === 200) {
        this.data = []
        this.summation = {
          betAmount: 0,
          winLose: 0,
          rollingAmount: 0,
        }
        if (res.data.todayList != null) {
          res.data.todayList.forEach(v => {
            // this.data.push(v)
            this.summation.betAmount += v.betAmount
            this.summation.winLose += v.winLose
            this.summation.rollingAmount += v.rollingAmount
          })
        }
        res.data.list.forEach(v => {
          // this.data.push(v)
          this.summation.betAmount += v.betAmount
          this.summation.winLose += v.winLose
          this.summation.rollingAmount += v.rollingAmount
        })

        this.pagination.page = page
        this.pagination.rowsPerPage = rowsPerPage
        this.pagination.rowsNumber = res.data.count
        this.pagination.sortBy = sortBy
        this.pagination.descending = descending
        this.loading = false

        return res.data.list
      }
    },
    showUserDetial(username, prefix) {
      if (this.scopedAgent) return
      // พา prefix ของ agent เจ้าของไปด้วย — ชื่อผู้ใช้ลูกค้าซ้ำข้ามสายได้ หน้าปลายทางต้องรู้ว่าคนไหน
      this.$router.push(`members/edit?id=${encodeURIComponent(username)}&prefix=${encodeURIComponent(prefix || '')}`)
    },
    // refundBet(v) {
    //   this.$swal({
    //     dark: true,
    //     title: this.$t('Are you sure?'),
    //     text: this.$t('คุณเเน่ใจว่าต้องการลบข้อมูลใช่หรือไม่'),
    //     icon: 'info',
    //     showCancelButton: true,
    //     confirmButtonText: this.$t('Ok'),
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //       cancelButton: 'btn btn-outline-danger ml-1',
    //     },
    //     buttonsStyling: false,
    //   })
    //       .then(async result => {
    //         if (result.value) {
    //           const res = await lottoService.getAuthen(`bet/refund?username=${v.username}&txId=${v.txId}`)
    //           if (res.status === 200) {
    //             const { bet } = res.data
    //             v.beforeBalance = bet.beforeBalance
    //             v.afterBalance = bet.afterBalance
    //             v.balance = bet.balance
    //             v.currentBalance = bet.currentBalance
    //             v.status = bet.status
    //
    //             this.$toast({
    //               component: ToastificationContent,
    //               position: 'top-right',
    //               props: {
    //                 title: this.$t('สำเร็จ'),
    //                 icon: 'CoffeeIcon',
    //                 variant: 'success',
    //                 text: res.data,
    //               },
    //             })
    //           } else {
    //             this.$toast({
    //               component: ToastificationContent,
    //               position: 'top-right',
    //               props: {
    //                 title: this.$t('เกิดข้อผิดพลาด'),
    //                 icon: 'AlertCircleIcon',
    //                 variant: 'danger',
    //                 text: res.data,
    //               },
    //             })
    //           }
    //         }
    //       })
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.report-scope-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

</style>
